document.addEventListener("DOMContentLoaded", () => {
  // Default init: when CM is active, render CM data immediately
  $(`.incm-container.cm-active`).each(function(){
    const _that = $(this);
    _that.parents(`.table-section`).find(`.size-table-wrap table td`).each(function(){
      const tempAttr = $(this).attr(`data-cm`);
      if (tempAttr != null) $(this).html(tempAttr);
    });
    _that.attr('aria-label', _that.attr('data-inch-tips'));
    _that.attr('aria-pressed', 'true');
  });

  // In ~ CM 切换
  $(document).off('click', '.incm-container').on('click', '.incm-container', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var _that = $(this);
    if(_that.hasClass(`cm-active`)){
      _that.parents(`.table-section`).find(`.size-table-wrap table td`).each(function(){
        let tempAttr = $(this).attr(`data-inch`);
        $(this).html(tempAttr);
      });
      _that.removeClass(`cm-active`);
      _that.attr('aria-label', _that.attr('data-cm-tips'));
      _that.attr('aria-pressed', 'false');
    }else{
      _that.parents(`.table-section`).find(`.size-table-wrap table td`).each(function(){
        let tempAttr = $(this).attr(`data-cm`);
        $(this).html(tempAttr);
      });
      _that.addClass(`cm-active`);
      _that.attr('aria-label', _that.attr('data-inch-tips'));
      _that.attr('aria-pressed', 'true');
    }
  });
  $(document).off('keydown', '.incm-container').on('keydown', '.incm-container', function(e) {
    if(e.key == 'Enter' || e.key == ' '){
      e.preventDefault();
      e.stopPropagation();
      $(this).click();
    }
  });
  $(document).off('mouseenter', '.size-table-wrap table td').on('mouseenter', '.size-table-wrap table td', function(e){
    e.preventDefault();
    e.stopPropagation();
    let cellIndex = e.currentTarget.cellIndex;
    $(this).addClass(`selected-table-element`);
    if($(this).prevAll(`th`).length > 0) {
      $(this).prevAll(`th`).addClass(`cross-section-header`);
      $(this).prevAll(`td`).addClass(`cross-section-data`);
    };
    $(this).parents(`table`).find("thead th").eq(cellIndex).addClass(`cross-section-header`);
    $(this).parent().prevAll(`tr`).each(function(){
      $(this).children(`th`).eq(cellIndex).addClass(`cross-section-header`);
      let th_length = $(this).children(`th`).length;
      th_length > 0 ? $(this).children(`td`).eq(cellIndex - th_length).addClass(`cross-section-data`) : $(this).children(`td`).eq(cellIndex).addClass(`cross-section-data`);
    });
  });
  $(document).off('mouseleave', '.size-table-wrap table td').on('mouseleave', '.size-table-wrap table td', function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass(`selected-table-element`);
    $(`.size-table-wrap table td`).removeClass(`cross-section-data`);
    $(`.size-table-wrap table th`).removeClass(`cross-section-header`);
  });

  // Size guide top tabs
  function toggleSizeGuideFaq(tabKey) {
    const $faqSection = $('.size-guide-faq').closest('.shopify-section');
    if(!$faqSection.length) {
      return;
    }
    $faqSection.toggleClass('hidden', tabKey !== 'size-guide');
  }

  function toggleSizeGuideShop(tabKey) {
    $('.size-guide-shop-cta').each(function() {
      const $root = $(this);
      const $section = $root.closest('.shopify-section');
      const matchTab = String($root.data('size-shop-tab') || '');
      const shouldShow = tabKey !== 'size-guide' && tabKey === matchTab;
      $section.toggleClass('hidden', !shouldShow);
    });
  }

  function activateGuideTab(tabKey) {
    if(!tabKey) {
      return;
    }
    const $tabContainer = $('.size-guide-tabs');
    $tabContainer.find('.size-guide-tab').removeClass('is-active').attr('aria-selected', 'false');
    $tabContainer.find(`.size-guide-tab[data-size-guide-tab="${tabKey}"]`).addClass('is-active').attr('aria-selected', 'true');
    $('.size-guide-container > .size-guide-item[data-size-tab]').each(function(){
      const $item = $(this);
      const itemKey = $item.data('size-tab');
      $item.toggleClass('hidden', itemKey !== tabKey);
    });
    toggleSizeGuideFaq(tabKey);
    toggleSizeGuideShop(tabKey);
    requestAnimationFrame(() => scrollActiveTabIntoView());
  }

  function scrollActiveTabIntoView() {
    const tabContainer = document.querySelector('.size-guide-tabs');
    const activeTab = tabContainer?.querySelector('.size-guide-tab.is-active');
    if (!tabContainer || !activeTab) return;

    if (!window.matchMedia('(max-width: 590px)').matches) return;

    activeTab.scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
      block: 'nearest'
    });
  }

  function scrollToSizeGuideTabs() {
    const tabEl = document.querySelector('.size-guide-tabs');
    if (!tabEl) return;

    const announceBarHeight = document.querySelector('.announcement-bar-section')?.clientHeight || 0;
    const headerHeight = document.querySelector('.section-header')?.clientHeight || 0;
    const barHeight = document.querySelector('common-scroll-to-bar .stb__item-list')?.clientHeight || 0;
    const offset = announceBarHeight + headerHeight + barHeight + 10;

    const top = tabEl.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  $(document).off('click', '.size-guide-tab').on('click', '.size-guide-tab', function(e) {
    if($('.size-guide-tabs').hasClass('is-dragging')) {
      return;
    }
    e.preventDefault();
    const tabKey = $(this).data('size-guide-tab');
    activateGuideTab(tabKey);
  });

  $(document).off('keydown', '.size-guide-tab').on('keydown', '.size-guide-tab', function(e) {
    if(e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();
      $(this).click();
    }
  });

  $(document).off('click', '.size-guide-card').on('click', '.size-guide-card', function(e) {
    e.preventDefault();
    const targetTab = $(this).data('size-guide-target');
    activateGuideTab(targetTab);
    requestAnimationFrame(() => scrollToSizeGuideTabs());
  });

  $(document).off('keydown', '.size-guide-card').on('keydown', '.size-guide-card', function(e) {
    if(e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();
      $(this).click();
    }
  });

  const initialTab = $('.size-guide-tab.is-active').first().data('size-guide-tab') || $('.size-guide-tab').first().data('size-guide-tab');
  activateGuideTab(initialTab);

  // Mobile: draggable horizontal scroll for tabs
  (function initTabsDragScroll() {
    const $tabs = $('.size-guide-tabs');
    if(!$tabs.length) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = 0;

    function setDragging(on) {
      $tabs.toggleClass('is-dragging', on);
      if(on) {
        $tabs.css('cursor', 'grabbing');
      } else {
        $tabs.css('cursor', '');
      }
    }

    $tabs.off('mousedown.sizeTabsDrag').on('mousedown.sizeTabsDrag', function(e) {
      // only left mouse button
      if(e.button !== 0) return;
      isDown = true;
      moved = 0;
      startX = e.pageX - $tabs.offset().left;
      scrollLeft = $tabs.scrollLeft();
      setDragging(false);
    });

    $(document).off('mousemove.sizeTabsDrag').on('mousemove.sizeTabsDrag', function(e) {
      if(!isDown) return;
      const x = e.pageX - $tabs.offset().left;
      const walk = x - startX;
      moved = Math.max(moved, Math.abs(walk));
      $tabs.scrollLeft(scrollLeft - walk);
      if(moved > 6) setDragging(true);
    });

    $(document).off('mouseup.sizeTabsDrag').on('mouseup.sizeTabsDrag', function() {
      if(!isDown) return;
      isDown = false;
      // keep is-dragging briefly to prevent click firing after drag
      if($tabs.hasClass('is-dragging')) {
        setTimeout(() => setDragging(false), 80);
      } else {
        setDragging(false);
      }
    });

    $tabs.off('touchstart.sizeTabsDrag').on('touchstart.sizeTabsDrag', function(e) {
      const touch = e.originalEvent.touches && e.originalEvent.touches[0];
      if(!touch) return;
      isDown = true;
      moved = 0;
      startX = touch.pageX - $tabs.offset().left;
      scrollLeft = $tabs.scrollLeft();
      setDragging(false);
    });

    $tabs.off('touchmove.sizeTabsDrag').on('touchmove.sizeTabsDrag', function(e) {
      if(!isDown) return;
      const touch = e.originalEvent.touches && e.originalEvent.touches[0];
      if(!touch) return;
      const x = touch.pageX - $tabs.offset().left;
      const walk = x - startX;
      moved = Math.max(moved, Math.abs(walk));
      $tabs.scrollLeft(scrollLeft - walk);
      if(moved > 6) setDragging(true);
      if(moved > 6) e.preventDefault();
    });

    $tabs.off('touchend.sizeTabsDrag touchcancel.sizeTabsDrag').on('touchend.sizeTabsDrag touchcancel.sizeTabsDrag', function() {
      if(!isDown) return;
      isDown = false;
      if($tabs.hasClass('is-dragging')) {
        setTimeout(() => setDragging(false), 80);
      } else {
        setDragging(false);
      }
    });
  })();

  // Size subfilter switch
  function activateSubfilter($group, target) {
    if(!$group.length || !target) {
      return;
    }
    $group.find('.size-subfilter-button').removeClass('is-active');
    $group.find(`.size-subfilter-button[data-size-subfilter-target="${target}"]`).addClass('is-active');
    $group.find('.size-subfilter-panel').removeClass('is-active');
    $group.find(`.size-subfilter-panel[data-size-subfilter-panel="${target}"]`).addClass('is-active');
  }

  $(document).off('click', '.size-subfilter-button').on('click', '.size-subfilter-button', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const $button = $(this);
    const $group = $button.closest('.size-subfilter-group');
    const target = $button.data('size-subfilter-target');
    activateSubfilter($group, target);
  });

  $(document).off('keydown', '.size-subfilter-button').on('keydown', '.size-subfilter-button', function(e) {
    if(e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();
      e.stopPropagation();
      $(this).click();
    }
  });

  $('.size-subfilter-group').each(function() {
    const $group = $(this);
    const $activeButton = $group.find('.size-subfilter-button.is-active').first();
    const target = $activeButton.data('size-subfilter-target') || $group.find('.size-subfilter-button').first().data('size-subfilter-target');
    activateSubfilter($group, target);
  });
});
